/* ------------------------------------------------------------------------ *\
 * Swiper
\* ------------------------------------------------------------------------ */

import Swiper from "swiper";
import { A11y, Autoplay, Controller, EffectCards, EffectCoverflow, EffectCreative, EffectCube, EffectFade, EffectFlip, FreeMode, Grid, HashNavigation, History, Keyboard, Manipulation, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom } from "swiper/modules";

// Global registry for Swiper instances
window.WeblinxSwipers = window.WeblinxSwipers || {
    instances: new Map(),

    // Add a Swiper instance to the registry
    register(element, instance) {
        const id = element.id || `swiper-${this.instances.size}`;
        element.id = id; // Ensure element has an ID
        this.instances.set(id, instance);
        return id;
    },

    // Get a Swiper instance by element ID
    get(id) {
        return this.instances.get(id);
    },

    // Get all Swiper instances
    getAll() {
        return Array.from(this.instances.values());
    },

    // Get all instances as an object with IDs as keys
    getAllAsObject() {
        return Object.fromEntries(this.instances);
    },

    // Remove a Swiper instance from the registry
    unregister(id) {
        return this.instances.delete(id);
    },

    // Destroy and unregister a Swiper instance
    destroy(id) {
        const instance = this.instances.get(id);
        if (instance) {
            instance.destroy();
            this.instances.delete(id);
        }
    },

    // Destroy all Swiper instances
    destroyAll() {
        this.instances.forEach(instance => instance.destroy());
        this.instances.clear();
    }
};

function initSwipers(root) {
    root = root || document;

    root.querySelectorAll(".swiper-container--weblinx-swiper").forEach(function (swiperElement) {
        if (swiperElement.dataset.swiperInitialized) {
            return;
        }

        const swiperInstance = new Swiper(swiperElement, Object.assign({
            modules: [A11y, Autoplay, Controller, EffectCards, EffectCoverflow, EffectCreative, EffectCube, EffectFade, EffectFlip, FreeMode, Grid, HashNavigation, History, Keyboard, Manipulation, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom]
        }, JSON.parse(swiperElement.dataset.config || "{}")));

        window.WeblinxSwipers.register(swiperElement, swiperInstance);
        swiperElement.dataset.swiperInitialized = "true";
    });
}

// Standard front-end init
initSwipers();

// Block editor (Gutenberg) init
if (window.wp && window.wp.domReady && window.wp.data) {
    window.wp.domReady(function () {
        window.wp.data.subscribe(function () {
            const editor = window.wp.data.select("core/editor");
            if (editor && !editor.isSavingPost()) {
                initSwipers();
            }
        });

        // MutationObserver fallback for iframed editor canvas (WP 6.3+)
        const iframeEl = document.querySelector(".editor-canvas__iframe") || document.querySelector("[name='editor-canvas']");
        const editorCanvas = (iframeEl && iframeEl.contentDocument) ? iframeEl.contentDocument : document;
        const editorRoot = editorCanvas.body || editorCanvas.documentElement;

        const observer = new MutationObserver(function () {
            initSwipers(editorCanvas);
        });

        observer.observe(editorRoot, {
            childList: true,
            subtree: true,
        });
    });
}
